import useSubadminTableColumns from './useSubadminTableColumns'

export default useSubadminTableColumns
